export const PRIVACY_URL = "https://www.iubenda.com/privacy-policy/86529881";
export const COOKIE_URL = "https://www.iubenda.com/privacy-policy/86529881/cookie-policy";
export const CONTACT_EMAIL = "pm.giordano@astralsand.com";

export const copy = {
  en: {
    subline: "Technology for your nights",
    comingSoon: "Coming soon",
    sound: "Sound",
    scrollDown: "Scroll down",
    emailLabel: "Email address",
    emailPlaceholder: "you@example.com",
    join: "Join the waitlist",
    sending: "One moment…",
    consentBefore: "I agree to receive updates about Astralsand. See our ",
    privacy: "Privacy Policy",
    consentAfter: ".",
    invalidEmail: "That email doesn't look right.",
    needConsent: "Please tick the box so we can write to you.",
    rateLimited: "Too many attempts. Please try again later.",
    genericError: "Something went wrong. Please try again later.",
    thanksTitle: "Thank you.",
    thanksBody: "You're on the list. We'll be in touch.",
    cookiePolicy: "Cookie Policy",
    contact: "Contact",
    cookiePrefs: "Cookie preferences",
  },
  it: {
    subline: "Tecnologia per le tue notti",
    comingSoon: "Prossimamente",
    sound: "Suono",
    scrollDown: "Scorri in basso",
    emailLabel: "Indirizzo email",
    emailPlaceholder: "tu@esempio.it",
    join: "Unisciti alla lista d'attesa",
    sending: "Un attimo…",
    consentBefore: "Accetto di ricevere aggiornamenti su Astralsand. Leggi la nostra ",
    privacy: "Privacy Policy",
    consentAfter: ".",
    invalidEmail: "Questa email non sembra corretta.",
    needConsent: "Spunta la casella così possiamo scriverti.",
    rateLimited: "Troppi tentativi. Riprova più tardi.",
    genericError: "Qualcosa è andato storto. Riprova più tardi.",
    thanksTitle: "Grazie.",
    thanksBody: "Sei nella lista. Ti scriveremo presto.",
    cookiePolicy: "Cookie Policy",
    contact: "Contatti",
    cookiePrefs: "Preferenze cookie",
  },
};
